export enum OptionType {
  User = 1,
  Country = 2,
  Province = 3,
  District = 4,
  Ward = 5,
  Role = 6,

  Fanpage = 7,
  ProjectManager = 8,
  UserManager = 9,
  UserInTeam = 10,

  UserBank = 11,
  Bank = 12,
  Currency=13
}
